module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVBAMAAABbObilAAAALVBMVEUAAABBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiND///8eDGt6AAAADXRSTlMA8cskjU+3rjMw5Y5IM7mwnwAAAHJJREFUCNdjAIIpWrdUJjCAgfldILhuAGLyyN4FARkQO/YuBAQwMDDLQtnCDAxsd6HgGgND710YaGDYC2c7MOjC2QoMa+FsAQYgce/du3dA6gKDLJwtgKwe2RwU8xH2IrsH1Z0MrBAJUVR/gf2reBHsXwARZY4XFJywyQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_cancel_hover.png
// module id = EFTc
// module chunks = 9